import styled from 'styled-components';
import { ActionButton } from './ActionButton.styled';

export const SaveButton = styled(ActionButton)`
    background-color: darkblue;

    /* font */
    font-weight: 600;
`;